/* eslint-disable no-prototype-builtins */
import { Button, Card, Grid, IconButton, LinearProgress } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { ArrowDownward, ArrowUpward } from "@mui/icons-material";
import PCheck from "../../components/pos/PCheck";
import PDatePicker from "../../components/pos/PDatePicker";
import PSelect from "../../components/pos/PSelect";
import db from "../../db/db";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { PDFObject } from "react-pdfobject";
import API from "../../utils/API";
import { StringUtils } from "../../utils/StringUtils";

import parse from "html-react-parser";
import { blue } from "@mui/material/colors";
import ReportViewer from "./ReportViewer";
import { Box } from "@mui/system";
import { PrintUtils } from "../../utils/PrintUtils";
import PFileViewer from "../../components/pos/PFileViewer";

export default function ReportHomeVertical(props) {
  const { t, i18n } = useTranslation();
  const translate = t;
  const [reports, setReports] = useState({});

  const [mainReportOptions, setMainReportOptions] = useState([]);
  const [mainReport, setMainReport] = useState();
  const [subReportOptions, setSubReportOptions] = useState([]);
  const [subReport, setSubReport] = useState();

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [defaultEndDate, setDefaultEndDate] = useState();
  const [endDateLabel, setEndDateLabel] = useState();
  const [startDateLabel, setStartDateLabel] = useState();

  const [showSubReport, setShowSubReport] = useState(false);
  const [showStartDate, setShowStartDate] = useState(false);
  const [showEndDate, setShowEndDate] = useState(false);

  const [enableGenerate, setEnableGenerate] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);

  const [showDept, setShowDept] = useState(false);
  const [showSubDept, setShowSubDept] = useState(false);
  const [showCategory, setShowCategory] = useState(false);
  const [showSubCategory, setShowSubCategory] = useState(false);

  const [showCheck1, setShowCheck1] = useState(false);
  const [check1Label, setCheck1Label] = useState("");
  const [check1, setCheck1] = useState(false);
  const [check1Key, setCheck1Key] = useState("");

  const [showCheck2, setShowCheck2] = useState(false);
  const [check2Label, setCheck2Label] = useState("");
  const [check2, setCheck2] = useState(false);
  const [check2Key, setCheck2Key] = useState("");

  const [showCheck3, setShowCheck3] = useState(false);
  const [check3Label, setCheck3Label] = useState("");
  const [check3, setCheck3] = useState(false);
  const [check3Key, setCheck3Key] = useState("");

  const [showCheck4, setShowCheck4] = useState(false);
  const [check4Label, setCheck4Label] = useState("");
  const [check4, setCheck4] = useState(false);
  const [check4Key, setCheck4Key] = useState("");

  const [deptId, setDeptId] = useState(null);
  const [deptIdOptions, setDeptidOptions] = useState([]);

  const [subDeptId, setSubDeptId] = useState(null);
  const [subDeptIdOptions, setSubDeptIdOptions] = useState([]);

  const [categoryId, setCategoryId] = useState(null);
  const [categoryIdOptions, setCategoryIdOptions] = useState([]);

  const [subCategoryId, setSubCategoryId] = useState(null);
  const [subCategoryIdOptions, setSubCategoryIdOptions] = useState([]);

  const [ledgerId, setLedgerId] = useState(null);
  const [ledgerOptions, setLedgerOptions] = useState(null);
  const [showLedgerSelection, setShowLedgerSelection] = useState(false);

  const [showSort, setShowSort] = useState(false);
  const [sort, setSort] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [sortOptions, setSortOptions] = useState([]);

  const [showOptionSelector1, setShowOptionSelector1] = useState(false);
  const [optionSelector1Options, setOptionSelector1Options] = useState([]);
  const [optionSelector1Value, setOptionSelector1Value] = useState("");
  const [optionSelector1Label, setOptionSelector1Label] = useState("");

  const [showVendorSelector, setShowVendorSelector] = useState(false);
  const [vendorSelectorOptions, setVendorSelectorOptions] = useState([]);

  const [vendorSelectorValue, setVendorSelectorValue] = useState("");

  const [showBranchSelector, setShowBranchSelector] = useState(false);
  const [branchSelectorOptions, setBranchSelectorOptions] = useState([]);
  const [branchSelectorValue, setBranchSelectorValue] = useState("");

  const [financialYearOptions, setFinancialYearOptions] = useState([]);
  const [showFinancialYear, setShowFinancialYear] = useState(false);
  const [financialYearValue, setFinancialYearValue] = useState([]);

  const [showUserSelector, setShowUserSelector] = useState(false);
  const [userSelectorOptions, setUserSelectorOptions] = useState([]);
  const [userSelectorValue, setUserSelectorValue] = useState("");

  const [showTerminalSelector, setShowTerminalSelector] = useState(false);
  const [terminalSelectorOptions, setTerminalSelectorOptions] = useState([]);
  const [terminalSelectorValue, setTerminalSelectorValue] = useState("");

  const [reportRequest, setReportRequest] = useState({});
  const [pluginMode, setPluginMode] = useState(null);

  const [reportUrl, setReportUrl] = useState("");
  const [htmlReport, setHtmlReport] = useState();
  const [showPopupReport, setShowPopupReport] = useState(false);
  const [popUpReportParams, setPopUpReportParams] = useState();
  const [popupReportTitle, setPopupReportTitle] = useState("Report");
  const [popupReportWidth, setPopupReportWidth] = useState("md");

  const [pdfOption, setPdfOption] = useState(false);
  const [htmlOption, setHtmlOption] = useState(false);
  const [excelOption, setExcelOptiopn] = useState(false);
  const [generateLabelXs, setGenerateLabelXs] = useState(12);

  const [openFileViewWindow, setOpenFileViewWindow] = useState(false);
  const [previewFileList, setPreviewFileList] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    if (sortOptions) {
      for (let s of sortOptions) {
        if (s.default) {
          setSort(s);
          if (s.defaultSort) {
            setSortOrder(s.defaultSort);
          }
        }
      }
    }
  }, [sortOptions]);

  async function loadData() {
    let { data } = await API.get("/report/available");
    setReports(data);
    let mainMenuOption = [];
    for (var key in data) {
      if (
        data.hasOwnProperty(key) &&
        key != "generic" &&
        key != "analytics" &&
        key != "export"
      ) {
        mainMenuOption.push({
          id: key,
          name: data[key].config.label,
          config: data[key],
        });
      }
    }
    setMainReportOptions(mainMenuOption);
    db.category
      .where("level")
      .equals(0)
      .toArray(function (data) {
        let dat = [];
        dat.push({
          id: "All",
          name: "All",
          code: "All",
        });
        for (let i = 0; i < data.length; i++) {
          if (!data[i].parent_id) {
            dat.push({
              id: data[i].id,
              name: data[i].name,
              code: data[i].catCode,
            });
          }
        }
        setDeptidOptions(dat);
      });

    let result = await API.get("/api/v1/allvendors");
    let dat = [];
    dat.push({ id: "all", name: "All" });
    for (let i = 0; i < result.data.length; i++) {
      dat.push({
        id: result.data[i].id,
        name: result.data[i].name,
      });
    }

    setVendorSelectorOptions(dat);
    let d = [];
    if (props.context.store.branches) {
      for (let b of props.context.store.branches) {
        d.push({
          id: b.code,
          name: b.code,
        });
      }
    }
    setBranchSelectorOptions(d);

    let result2 = await API.get("/api/v1/allfinancialyears");
    let dat1 = [];
    dat.push({ id: "all", name: "All" });
    let actionFy = null;
    for (let i = 0; i < result2.data.length; i++) {
      if (result2.data[i].active) {
        setFinancialYearValue({
          id: result2.data[i].id,
          name: result2.data[i].name,
        });
        actionFy = result2.data[i];
        break;
      }
    }

    for (let i = 0; i < result2.data.length; i++) {
      if (
        result2.data[i].financialYearEndDate < actionFy.financialYearEndDate
      ) {
        dat1.push({
          id: result2.data[i].id,
          name: result2.data[i].name,
        });
      }
    }

    setFinancialYearOptions(dat1);

    let result3 = await API.get("/auth/v1/users/list");
    let users = [];
    users.push({ id: "all", name: "All" });
    for (let d of result3.data) {
      users.push({
        id: d.username,
        name: d.username,
      });
    }
    setUserSelectorOptions(users);

    let result4 = await API.get("/api/v1/allterminals");
    let terminals = [];
    terminals.push({ id: null, name: "All" });
    for (let d of result4.data) {
      terminals.push({
        id: d.id,
        name: d.name,
      });
    }
    setTerminalSelectorOptions(terminals);
  }

  function mainReportChanged(mainReport) {
    setPdfOption(false);
    setHtmlOption(false);
    setExcelOptiopn(false);

    setShowSubReport(false);
    setEnableGenerate(false);
    setShowLedgerSelection(false);
    setShowSort(false);
    setShowDept(false);
    setShowSubDept(false);
    setShowCategory(false);
    setShowSubCategory(false);
    setShowStartDate(false);
    setShowEndDate(false);
    setShowCheck1(false);
    setShowCheck2(false);
    setShowCheck3(false);
    setShowCheck4(false);

    setShowVendorSelector(false);
    setShowBranchSelector(false);
    setShowFinancialYear(false);
    setShowUserSelector(false);
    setShowOptionSelector1(false);
    setSubReport(null);
    setPluginMode(null);

    if (mainReport) {
      let subMenuOption = [];
      reports[mainReport.id].children.forEach(function (c) {
        if (props.context.privileges[c.name]) {
          subMenuOption.push({
            id: c.name,
            name: c.config.label,
            config: c,
          });
        }
      });
      setSubReportOptions(subMenuOption);
      setEnableGenerate(false);
      setShowSubReport(true);
    }
  }
  function subReportChanged(value) {
    setPdfOption(false);
    setHtmlOption(false);
    setExcelOptiopn(false);
    setEnableGenerate(false);
    setShowSort(false);
    setShowDept(false);
    setShowSubDept(false);
    setShowCategory(false);
    setShowSubCategory(false);
    setShowStartDate(false);
    setShowEndDate(false);
    setShowLedgerSelection(false);
    setSubReport(value);
    setPluginMode(null);

    setShowSort(false);
    setShowCheck1(false);
    setShowCheck2(false);
    setShowCheck3(false);
    setShowCheck4(false);
    setShowVendorSelector(false);
    setShowBranchSelector(false);
    setShowFinancialYear(false);
    setShowUserSelector(false);
    setShowOptionSelector1(false);
    let count = 0;
    if (value.config && value.config.config.reportFormat) {
      if (
        value.config.config.reportFormat.html &&
        value.config.config.reportFormat.html.show
      ) {
        setHtmlOption(true);
        count++;
      }
      if (
        value.config.config.reportFormat.pdf &&
        value.config.config.reportFormat.pdf.show
      ) {
        setPdfOption(true);
        count++;
      }
      if (
        value.config.config.reportFormat.excel &&
        value.config.config.reportFormat.excel.show
      ) {
        setExcelOptiopn(true);
        count++;
      }
    } else {
      setPdfOption(true);
      count++;
    }

    setGenerateLabelXs(count == 0 ? 12 : 12 / count);

    console.log(">>>>", value);

    if (value) {
      setEnableGenerate(true);
      let config = getSelectedReportConfig(value);
      if (config.plugin_mode) {
        setPluginMode(config.plugin_mode);
      }
      if (config.paramList) {
        for (var param of config.paramList) {
          if (param.key === "startDate") {
            let dt = getDate(param);
            setShowStartDate(true);
            setStartDateLabel(param.label ? param.label : "From");
            setStartDate(StringUtils.formatDate(dt, 2));
          }
          if (param.key === "endDate") {
            let dt = getDate(param);
            setShowEndDate(true);
            setEndDateLabel(param.label ? param.label : "To");
            setEndDate(StringUtils.formatDate(dt, 2));
          }
          if (param.type === "CategorySelector") {
            if (param.level >= 1) {
              setShowDept(true);
              setDeptId(null);
            }
            if (param.level >= 2) {
              setShowSubDept(true);
              setSubDeptId(null);
            }
            if (param.level >= 3) {
              setShowCategory(true);
              setCategoryId(null);
            }
            if (param.level >= 4) {
              setShowSubCategory(true);
              setSubCategoryId(null);
            }
          }
          if (param.type === "VendorSelector") {
            setShowVendorSelector(true);
            setVendorSelectorValue(null);
          }
          if (param.type === "BranchSelector") {
            setShowBranchSelector(true);
            setBranchSelectorValue(null);
          }
          if (param.type === "FinancialYearSelector") {
            setShowFinancialYear(true);
            //setFinancialYearValue(null);
          }

          if (param.type === "UserSelector") {
            setShowUserSelector(true);
            setUserSelectorValue(null);
          }
          if (param.type === "TerminalSelector") {
            setShowTerminalSelector(true);
            setTerminalSelectorValue(null);
          }

          if (param.type == "ledgerSelector") {
            if (financialYearValue != null && financialYearValue.id != "") {
              getAllLedgers(financialYearValue.id);
            }

            setShowLedgerSelection(true);
            setLedgerId(null);
          }

          if (param.type === "OptiionSelector1") {
            setOptionSelector1Label(param.label);

            let dat = [];
            for (let i = 0; i < param.values.length; i++) {
              dat.push({
                id: param.values[i].key,
                name: param.values[i].label,
                key: param.key,
                label: param.label,
              });
            }

            setShowOptionSelector1(true);
            setOptionSelector1Options(dat);
            setOptionSelector1Value("");
          }
          if (param.type === "Check1") {
            setShowCheck1(true);
            setCheck1Label(param.label);
            setCheck1(param.value);
            setCheck1Key(param.key);
          }
          if (param.type === "Check2") {
            setShowCheck2(true);
            setCheck2Label(param.label);
            setCheck2(param.value);
            setCheck2Key(param.key);
          }
          if (param.type === "Check3") {
            setShowCheck3(true);
            setCheck3Label(param.label);
            setCheck3(param.value);
            setCheck3Key(param.key);
          }
          if (param.type === "Check4") {
            setShowCheck4(true);
            setCheck4Label(param.label);
            setCheck4(param.value);
            setCheck4Key(param.key);
          }
        }
      }
      if (config.sort) {
        setShowSort(true);
        let dat = [];
        let defaultSort;
        for (let s of config.sort) {
          dat.push({
            id: s.key,
            name: s.label,
            code: s.label,
            default: s.default,
            defaultSort: s.defaultOrder,
          });
        }
        setSortOptions(dat);
        setSort(null);
        setSortOrder("ASC");
      }
    }
  }

  async function getAllLedgers(financialYearId) {
    setLedgerId(null);
    setLedgerOptions([]);
    let { data } = await API.get(
      "/api/v1/ledgerlistbyfinancialyear/" + financialYearId
    );
    let options = [];

    for (let i = 0; i < data.length; i++) {
      options.push({ id: data[i].id, name: data[i].name });
    }
    setLedgerOptions(options);
  }

  function getDate(param) {
    if (param.defaultValue) {
      if (param.defaultValue === "startOfMonth") {
        let dt = new Date();
        return new Date(dt.getFullYear(), dt.getMonth(), 1);
      } else if (param.defaultValue === "endOfMonth") {
        let dt = new Date();

        return new Date(
          dt.getFullYear(),
          dt.getMonth(),
          this.daysInMonth(dt.getMonth() + 1, dt.getFullYear())
        );
      } else if (param.defaultValue === "today") {
        return new Date();
      }
    } else {
      return new Date();
    }
  }
  function daysInMonth(month, year) {
    return new Date(year, month, 0).getDate();
  }

  function getSelectedReportConfig(selectedReport) {
    let config = {};
    reports[mainReport.id].children.forEach(function (c) {
      if (c.name === selectedReport.id) {
        config = c.config;
        return;
      }
    });
    return config;
  }

  const onDownload = (url) => {
    const link = document.createElement("a");
    link.download = url;
    link.href = url;
    link.click();
  };

  function getDefaultFormat(config) {
    if (config.config.config.defaultReportFormat) {
      return config.config.config.defaultReportFormat;
    }
    return "pdf";
  }

  function onGenerateReportPdf() {
    onGenerateReport("pdf");
  }
  function onGenerateReportExcel() {
    onGenerateReport("excel");
  }
  function onGenerateReportHtml() {
    onGenerateReport("html");
  }

  async function onGenerateReport(outFormat) {
    setIsGenerating(true);
    setEnableGenerate(false);
    setHtmlReport(null);
    setReportUrl(null);

    let reportReq = {
      template: subReport.id,
      outFormat: outFormat,
      paramList: [],
    };

    if (showStartDate) {
      reportReq.paramList.push({
        key: "startDate",
        value: startDate,
        label: startDateLabel,
        labelValue: startDate,
      });
    }

    if (showEndDate) {
      reportReq.paramList.push({
        key: "endDate",
        value: endDate,
        label: endDateLabel,
        labelValue: endDate,
      });
    }
    if (showDept) {
      if (deptId && deptId.id != "All") {
        reportReq.paramList.push({
          key: "deptId",
          value: deptId.id,
          label: "Department",
          labelValue: deptId.name,
        });
      }
    }

    if (showLedgerSelection) {
      if (ledgerId) {
        reportReq.paramList.push({
          key: "ledgerId",
          value: ledgerId.id,
          label: "Ledger",
          labelValue: ledgerId.name,
        });
      }
    }

    if (showCheck1) {
      if (check1) {
        reportReq.paramList.push({
          key: check1Key,
          value: check1,
          label: check1Label,
          labelValue: check1,
        });
      }
    }
    if (showCheck2) {
      if (check2) {
        reportReq.paramList.push({
          key: check2Key,
          value: check2,
          label: check2Label,
          labelValue: check2,
        });
      }
    }
    if (showCheck3) {
      if (check3) {
        reportReq.paramList.push({
          key: check3Key,
          value: check3,
          label: check3Label,
          labelValue: check3,
        });
      }
    }
    if (showCheck4) {
      if (check4) {
        reportReq.paramList.push({
          key: check4Key,
          value: check4,
          label: check4Label,
          labelValue: check4,
        });
      }
    }
    if (showSubDept) {
      if (subDeptId && subDeptId.id != "All") {
        reportReq.paramList.push({
          key: "subDeptId",
          value: subDeptId.id,
          label: "Sub Department",
          labelValue: subDeptId.name,
        });
      }
    }

    if (showCategory) {
      if (categoryId && categoryId.id != "All") {
        reportReq.paramList.push({
          key: "categoryId",
          value: categoryId.id,
          label: "Category",
          labelValue: categoryId.name,
        });
      }
    }

    if (showSubCategory) {
      if (subCategoryId && subCategoryId.id != "All") {
        reportReq.paramList.push({
          key: "subCategoryId",
          value: subCategoryId.id,
          label: "Sub Category",
          labelValue: subCategoryId.name,
        });
      }
    }

    if (showSort) {
      if (sort) {
        reportReq["sort"] = {
          key: sort.id,
          label: sort.label,
          sortOrder: sortOrder,
        };
      }
    }

    if (showVendorSelector) {
      if (vendorSelectorValue && vendorSelectorValue.id != "all") {
        reportReq.paramList.push({
          key: "vendorId",
          value: vendorSelectorValue.id,
          label: "Vendor",
          labelValue: vendorSelectorValue.name,
        });
      }
    }

    if (showBranchSelector) {
      if (branchSelectorValue && branchSelectorValue.id != "all") {
        reportReq.paramList.push({
          key: "branchId",
          value: branchSelectorValue.id,
          label: "Branch",
          labelValue: branchSelectorValue.name,
        });
      }
    }

    if (showFinancialYear) {
      if (financialYearValue && financialYearValue.id != "all") {
        reportReq.paramList.push({
          key: "financialYear",
          value: financialYearValue.id,
          label: "Year",
          labelValue: financialYearValue.name,
        });
      }
    }

    if (showUserSelector) {
      if (userSelectorValue && userSelectorValue.id != "all") {
        reportReq.paramList.push({
          key: "userName",
          value: userSelectorValue.id,
          label: "Cashier",
          labelValue: userSelectorValue.name,
        });
      }
    }
    if (showTerminalSelector) {
      if (terminalSelectorValue && terminalSelectorValue.id != "all") {
        reportReq.paramList.push({
          key: "terminalId",
          value: terminalSelectorValue.id,
          label: "Terminal",
          labelValue: terminalSelectorValue.name,
        });
      }
    }

    if (showOptionSelector1) {
      if (optionSelector1Value && optionSelector1Value.id != "all") {
        reportReq.paramList.push({
          key: optionSelector1Value.key,
          value: optionSelector1Value.id,
          label: optionSelector1Value.label,
          labelValue: optionSelector1Value.name,
        });
      }
    }
    if (pluginMode) {
      reportReq.pluginMode = pluginMode;
    }
    try {
      setReportRequest(reportReq);

      let success = false;

      let { data } = await API.post("/report/generate_async", reportReq);
      let resultUrl = null;
      while (true) {
        let result = await API.get(
          "/report/generate_async/" + data.workRequestId,
          reportReq
        );
        if (result.data.status == "completed") {
          console.log(result.data);
          resultUrl = result.data.fileName;
          success = true;
          break;
        }
        if (result.data.status == "failed") {
          console.log(result.data);
          break;
        }
        await sleep(3000);
      }

      if (reportReq.outFormat === "html") {
        let result = await API.get("/report/download/" + resultUrl);
        let parsed = parse(result.data, {
          replace: (domNode) => {
            //
            if (
              domNode &&
              domNode.attribs &&
              domNode.attribs.report_link &&
              domNode.attribs.report_link === "pos_report_link" &&
              domNode.attribs.report_enable === "true"
            ) {
              return (
                <div
                  style={{ color: "blue" }}
                  onClick={(event) => {
                    htmlClick(
                      event,
                      domNode.attribs.report_params,
                      domNode.attribs.report_title,
                      domNode.attribs.report_window_size
                    );
                  }}
                >
                  <u>{domNode.attribs.report_value}</u>
                </div>
              );
            }
          },
        });

        setHtmlReport(parsed);
      } else if (reportReq.outFormat === "excel") {
        if (success) onDownload("/report/download/" + resultUrl);
      } else {
        if (success) setReportUrl("/report/download/" + resultUrl);
      }
      if (!success) {
        props.setAlert({
          show: true,
          title: translate("Failure"),
          message: translate("Not able to generate report"),
          type: "fail",
        });
      }
    } catch (e) {
      setIsGenerating(false);
      setEnableGenerate(true);
    }
    setEnableGenerate(true);
    setIsGenerating(false);
  }

  function htmlClick(event, action, title, size) {
    let reportParams = JSON.parse("{" + action + "}");
    if (reportParams.actionType && reportParams.actionType == "open_invoice") {
      openSale(reportParams.id);
    } else if (
      reportParams.actionType &&
      reportParams.actionType == "view_dayclose_receipt"
    ) {
      openDayCLoseReceipt(reportParams);
    } else {
      setPopUpReportParams(reportParams);
      setShowPopupReport(true);
      setPopupReportTitle(title);
      setPopupReportWidth(size);
    }
  }

  async function openDayCLoseReceipt(params) {
    let { data } = await API.get("/api/v1/salesession/getSession/" + params.id);
    viewFile(data, getDayCLoseFormat());
  }

  function getDayCLoseFormat() {
    if (props.context.storeAdmin.enableShift)
      return "DAY_CLOSE_SHIFT_SUMMARY_PRINT_FORMAT";
    else return "DAY_CLOSE_PRINT_FORMAT";
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async function viewFile(data, format) {
    props.showProgress(translate("Generating "));
    try {
      let pdf = await PrintUtils.generateReceiptAsPdf(format, data);

      let fileList = [];

      let item = {
        selected: true,
        previewObj: pdf.data,
        fileType: "DOCUMENT",
      };

      console.log(item);

      fileList.push(item);
      setPreviewFileList(fileList);
      setOpenFileViewWindow(true);
    } catch (err) {}
    props.hideProgress();
  }

  async function openSale(saleId) {
    try {
      let { data } = await API.get("/api/v1/sale/" + saleId);
      PrintUtils.augmentSaleDetailsForPrint(
        data,
        props.context.store.currencyDecimal,
        props.saleType
      );
      viewFile(data, "SALE_RECEIPT_PRINT_FORMAT");
    } catch (err) {
      console.error("ERROR", err);
      props.showMessage(
        "error",
        translate("Not able to retrive sale data from server")
      );
    }
  }

  async function generateExcelReport() {
    try {
      reportRequest.outFormat = "excel";
      let { data } = await API.post("/report/generate", reportRequest);
      onDownload("/report/download/" + data.fileName);
    } catch (e) {
      console.log(e);
    }
  }

  async function generatePdfReport() {
    try {
      reportRequest.outFormat = "pdf";
      let { data } = await API.post("/report/generate", reportRequest);
      setReportUrl("/report/download/" + data.fileName);
      setHtmlReport(null);
    } catch (e) {
      console.log(e);
    }
  }
  async function populateSubDept(option) {
    //setCatidOptions([]);
    //setSubcatidOptions([]);
    db.category.toArray(function (data) {
      let dat = [];
      if (option) {
        dat.push({ id: "All", name: "All" });
        for (let i = 0; i < data.length; i++) {
          if (data[i].parentId === option.id) {
            dat.push({ id: data[i].id, name: data[i].name });
          }
        }
        setSubDeptIdOptions(dat);
      }
    });
  }

  async function populateCategory(option) {
    //setCatidOptions([]);
    //setSubcatidOptions([]);
    db.category.toArray(function (data) {
      let dat = [];
      if (option) {
        dat.push({ id: "All", name: "All" });
        for (let i = 0; i < data.length; i++) {
          if (data[i].parentId === option.id) {
            dat.push({ id: data[i].id, name: data[i].name });
          }
        }
        setCategoryIdOptions(dat);
      }
    });
  }

  async function populateSubCategory(option) {
    //setCatidOptions([]);
    //setSubcatidOptions([]);
    db.category.toArray(function (data) {
      let dat = [];
      if (option) {
        dat.push({ id: "All", name: "All" });
        for (let i = 0; i < data.length; i++) {
          if (data[i].parentId === option.id) {
            dat.push({ id: data[i].id, name: data[i].name });
          }
        }
        setSubCategoryIdOptions(dat);
      }
    });
  }

  return (
    <Grid container style={{ height: "100vh" }}>
      <Grid
        item
        xs={2}
        style={{ height: "100%", backgroundColor: "white", padding: 10 }}
      >
        <Grid container>
          <Grid item xs={12} style={{ paddingLeft: "5px" }}>
            Report Group
          </Grid>
          <Grid item xs={12} style={{ padding: "2px", paddingLeft: 0 }}>
            <PSelect
              options={mainReportOptions}
              value={mainReport}
              onChange={(event, newValue) => {
                setMainReport(newValue);
                mainReportChanged(newValue);
              }}
            ></PSelect>
          </Grid>
          {showSubReport && (
            <Grid item xs={12} style={{ paddingLeft: "5px" }}>
              Report
            </Grid>
          )}
          <Grid item xs={12} style={{ padding: "2px" }}>
            {showSubReport && (
              <PSelect
                options={subReportOptions}
                value={subReport}
                onChange={(event, newValue) => {
                  subReportChanged(newValue);
                }}
              ></PSelect>
            )}
          </Grid>
          {showDept && (
            <Grid item xs={12} style={{ paddingLeft: "5px" }}>
              Department
            </Grid>
          )}
          {showDept && (
            <Grid item xs={12}>
              <PSelect
                options={deptIdOptions}
                value={deptId}
                onChange={(event, newValue) => {
                  setDeptId(newValue);
                  setSubDeptId(null);
                  populateSubDept(newValue);

                  setCategoryIdOptions(null);
                  setCategoryId(null);

                  setSubCategoryIdOptions(null);
                  setSubCategoryId(null);
                }}
              ></PSelect>
            </Grid>
          )}
          {showSubDept && (
            <Grid item xs={12} style={{ paddingLeft: "5px" }}>
              Sub Department
            </Grid>
          )}
          {showSubDept && (
            <Grid item xs={12}>
              <PSelect
                options={subDeptIdOptions}
                value={subDeptId}
                onChange={(event, newValue) => {
                  setSubDeptId(newValue);
                  populateCategory(newValue);
                  setCategoryId(null);
                  setSubCategoryIdOptions(null);
                  setSubCategoryId(null);
                }}
              ></PSelect>
            </Grid>
          )}
          {showCategory && (
            <Grid item xs={12} style={{ paddingLeft: "5px" }}>
              Category
            </Grid>
          )}
          {showCategory && (
            <Grid item xs={12}>
              <PSelect
                options={categoryIdOptions}
                value={categoryId}
                onChange={(event, newValue) => {
                  setCategoryId(newValue);
                  populateSubCategory(newValue);
                  setSubCategoryIdOptions(null);
                  setSubCategoryId(null);
                }}
              ></PSelect>
            </Grid>
          )}
          {showSubCategory && (
            <Grid item xs={12} style={{ paddingLeft: "5px" }}>
              Sub Category
            </Grid>
          )}
          {showSubCategory && (
            <Grid item xs={12}>
              <PSelect
                options={subCategoryIdOptions}
                value={subCategoryId}
                onChange={(event, newValue) => {
                  setSubCategoryId(newValue);
                }}
              ></PSelect>
            </Grid>
          )}
          {showVendorSelector && (
            <Grid item xs={12} style={{ paddingLeft: "5px" }}>
              Vendor
            </Grid>
          )}
          {showVendorSelector && (
            <Grid item xs={12}>
              <PSelect
                options={vendorSelectorOptions}
                value={vendorSelectorValue}
                onChange={(event, newValue) => {
                  setVendorSelectorValue(newValue);
                }}
              ></PSelect>
            </Grid>
          )}{" "}
          {showBranchSelector && (
            <Grid item xs={12} style={{ paddingLeft: "5px" }}>
              Branch
            </Grid>
          )}
          {showBranchSelector && (
            <Grid item xs={12}>
              <PSelect
                options={branchSelectorOptions}
                value={branchSelectorValue}
                onChange={(event, newValue) => {
                  setBranchSelectorValue(newValue);
                }}
              ></PSelect>
            </Grid>
          )}
          {showFinancialYear && (
            <Grid item xs={12} style={{ paddingLeft: "5px" }}>
              Financial Year
            </Grid>
          )}
          {showFinancialYear && (
            <Grid item xs={12}>
              <PSelect
                options={financialYearOptions}
                value={financialYearValue}
                onChange={(event, newValue) => {
                  setFinancialYearValue(newValue);
                  if (showLedgerSelection) {
                    getAllLedgers(newValue.id);
                  }
                }}
              ></PSelect>
            </Grid>
          )}
          {showTerminalSelector && (
            <Grid item xs={12} style={{ paddingLeft: "5px" }}>
              Terminal
            </Grid>
          )}
          {showTerminalSelector && (
            <Grid item xs={12}>
              <PSelect
                options={terminalSelectorOptions}
                value={terminalSelectorValue}
                onChange={(event, newValue) => {
                  setTerminalSelectorValue(newValue);
                }}
              ></PSelect>
            </Grid>
          )}
          {showUserSelector && (
            <Grid item xs={12} style={{ paddingLeft: "5px" }}>
              User
            </Grid>
          )}
          {showUserSelector && (
            <Grid item xs={12}>
              <PSelect
                options={userSelectorOptions}
                value={userSelectorValue}
                onChange={(event, newValue) => {
                  setUserSelectorValue(newValue);
                }}
              ></PSelect>
            </Grid>
          )}
          {showLedgerSelection && (
            <Grid item xs={12} style={{ paddingLeft: "5px" }}>
              Ledger
            </Grid>
          )}
          {showLedgerSelection && (
            <Grid item xs={12}>
              <PSelect
                options={ledgerOptions}
                value={ledgerId}
                onChange={(event, newValue) => {
                  setLedgerId(newValue);
                }}
              ></PSelect>
            </Grid>
          )}
          {showOptionSelector1 && (
            <Grid item xs={12} style={{ paddingLeft: "5px" }}>
              {optionSelector1Label}
            </Grid>
          )}
          {showOptionSelector1 && (
            <Grid item xs={12}>
              <PSelect
                options={optionSelector1Options}
                value={optionSelector1Value}
                onChange={(event, newValue) => {
                  setOptionSelector1Value(newValue);
                }}
              ></PSelect>
            </Grid>
          )}
          {showCheck1 && (
            <Grid item xs={12} style={{ padding: "2px", paddingLeft: "5px" }}>
              <PCheck
                onChange={(value) => setCheck1(value)}
                checked={check1}
                label={check1Label}
              ></PCheck>
            </Grid>
          )}
          {showCheck2 && (
            <Grid item xs={12} style={{ padding: "2px", paddingLeft: "5px" }}>
              <PCheck
                onChange={(value) => setCheck2(value)}
                checked={check2}
                label={check2Label}
              ></PCheck>
            </Grid>
          )}
          {showCheck3 && (
            <Grid item xs={12} style={{ padding: "2px", paddingLeft: "5px" }}>
              <PCheck
                onChange={(value) => setCheck3(value)}
                checked={check3}
                label={check3Label}
              ></PCheck>
            </Grid>
          )}
          {showCheck4 && (
            <Grid item xs={12} style={{ padding: "2px", paddingLeft: "5px" }}>
              <PCheck
                onChange={(value) => setCheck4(value)}
                checked={check4}
                label={check4Label}
              ></PCheck>
            </Grid>
          )}
          {showStartDate && (
            <Grid item xs={12} style={{ paddingLeft: "5px" }}>
              Start Date
            </Grid>
          )}
          <Grid item xs={12} style={{ padding: "2px", paddingLeft: "10px" }}>
            {showStartDate && (
              <PDatePicker
                value={startDate}
                onChange={(value) => {
                  setStartDate(StringUtils.formatDate(value.$d, 2));
                }}
              ></PDatePicker>
            )}
          </Grid>
          {showEndDate && (
            <Grid item xs={12} style={{ paddingLeft: "5px" }}>
              {endDateLabel}
            </Grid>
          )}
          <Grid item xs={12} style={{ padding: "2px", paddingLeft: "10px" }}>
            {showEndDate && (
              <PDatePicker
                value={endDate}
                onChange={(value) =>
                  setEndDate(StringUtils.formatDate(value.$d, 2))
                }
              ></PDatePicker>
            )}
          </Grid>
          {showSort && (
            <Grid item xs={12} style={{ paddingLeft: "5px" }}>
              Sort
            </Grid>
          )}
          {showSort && (
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={10}>
                  <PSelect
                    options={sortOptions}
                    value={sort}
                    onChange={(event, newValue) => {
                      setSort(newValue);
                    }}
                  ></PSelect>
                </Grid>
                <Grid item xs={2} style={{ paddingLeft: 7 }}>
                  <IconButton
                    aria-label="delete"
                    onClick={(event, newValue) => {
                      sortOrder == "ASC"
                        ? setSortOrder("DESC")
                        : setSortOrder("ASC");
                    }}
                  >
                    {sortOrder == "ASC" && <ArrowDownward />}
                    {sortOrder == "DESC" && <ArrowUpward />}
                  </IconButton>
                </Grid>
              </Grid>
            </Grid>
          )}
          {htmlOption && (
            <Grid
              item
              xs={generateLabelXs}
              style={{ marginTop: 10, paddingLeft: "2px" }}
            >
              <Button
                fullWidth={true}
                variant="contained"
                color="primary"
                disabled={!enableGenerate}
                onClick={onGenerateReportHtml}
              >
                HTML
              </Button>
            </Grid>
          )}
          {pdfOption && (
            <Grid
              item
              xs={generateLabelXs}
              style={{ marginTop: 10, paddingLeft: "2px" }}
            >
              <Button
                fullWidth={true}
                variant="contained"
                color="primary"
                disabled={!enableGenerate}
                onClick={onGenerateReportPdf}
              >
                PDF
              </Button>
            </Grid>
          )}
          {excelOption && (
            <Grid
              item
              xs={generateLabelXs}
              style={{ marginTop: 10, paddingLeft: "2px" }}
            >
              <Button
                fullWidth={true}
                variant="contained"
                color="primary"
                disabled={!enableGenerate}
                onClick={onGenerateReportExcel}
              >
                Excel
              </Button>
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid item xs={10} style={{ height: "100%" }}>
        <Grid container>
          <Grid item xs={12}>
            {isGenerating && <LinearProgress />}
            {reportUrl && reportUrl.length > 0 && (
              <PDFObject
                url={reportUrl}
                height={"100vh"}
                pdfOpenParams={{ PageMode: "bookmarks", view: "FitV" }}
              />
            )}

            {htmlReport && (
              <Box
                display="flex"
                justifyContent="center"
                //alignItems="center"
                //minHeight="100vh"
                style={{ backgroundColor: "lightgray", height: "93vh" }}
              >
                <Box sx={{ width: "80%", paddingTop: "20px" }}>
                  <Card sx={{ padding: "20px" }}> {htmlReport}</Card>
                </Box>
              </Box>
            )}
          </Grid>
        </Grid>
      </Grid>
      {showPopupReport && (
        <ReportViewer
          reportParams={popUpReportParams}
          open={showPopupReport}
          setOpen={setShowPopupReport}
          title={popupReportTitle}
          maxWidth={popupReportWidth}
        ></ReportViewer>
      )}
      <PFileViewer
        openWindow={openFileViewWindow}
        setOpenWindow={setOpenFileViewWindow}
        showMessage={props.showMessage}
        filesList={previewFileList}
        setAlert={props.setAlert}
        disableDefaultPrint={true}
      ></PFileViewer>
    </Grid>
  );
}
